import React from 'react';
import { Link } from 'react-router-dom';
import { sanityClient } from '../../lib/sanity';
import CourseCard from '../../components/CourseCard';

function Kids() {
  const [courses, setCourses] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    setLoading(true);
    sanityClient
      .fetch(`
        *[_type == "course" && category == "kids" && isActive == true] 
        | order(order asc) {
          _id,
          name,
          slug,
          mainImage,
          shortDescription,
          duration,
          ageRange
        }
      `)
      .then((data) => {
        setCourses(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching kids courses:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            {/* Breadcrumb */}
            <div className="flex items-center justify-center gap-2 text-sm text-gray-600 mb-4">
              <Link to="/academy" className="hover:text-[#F4900C] transition-colors">
                Academy
              </Link>
              <span>→</span>
              <span className="text-gray-900 font-semibold">Kids</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Kids <span className="text-[#F4900C]">Programs</span>
            </h1>
            
            <p className="text-xl text-gray-600">
              Fun and engaging financial literacy courses designed specifically for children. 
              Learning money management through play and interactive activities.
            </p>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-16">
        <div className="container-custom">
          {loading && (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#F4900C]"></div>
              <p className="text-gray-600 mt-4">Loading courses...</p>
            </div>
          )}

          {error && (
            <div className="text-center py-12">
              <p className="text-red-600 text-lg">Error loading courses: {error}</p>
            </div>
          )}

          {!loading && !error && courses.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600 text-xl">No courses available at the moment.</p>
              <p className="text-gray-500 mt-2">Check back soon for new programs!</p>
            </div>
          )}

          {!loading && !error && courses.length > 0 && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {courses.map((course) => (
                <CourseCard key={course._id} course={course} category="kids" />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Want to Learn More?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Contact us to find out which program is best for your child or to customize a program for your needs.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-gradient-to-r from-[#FED700] to-[#F4900C] text-gray-900 px-8 py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Kids;